import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from '@angular/material/dialog';
import { FamilyCodeTransmissionService } from '../../services/raintree/Transmission/familyCode-transmission.service';
import { FamilyCodeResponse } from '../../services/raintree/interfaces/family-code.interface';
import { ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import {
  MatAutocomplete,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { FcCodePopupComponent } from '../../views/common/dpnf/fc-code-popup/fc-code-popup.component';
import { PrimaryAccPopupComponent } from '../primary-acc-popup/primary-acc-popup.component';
import { DialogRef } from '@angular/cdk/dialog';
import { PrimaryMailPopupComponent } from '../primary-mail-popup/primary-mail-popup.component';
import { ConfirmationMergeComponent } from '../confirmation-merge/confirmation-merge.component';

@Component({
  selector: 'app-merge-popup',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    LoaderComponent,
    CommonModule,
  ],
  templateUrl: './merge-popup.component.html',
  styleUrl: './merge-popup.component.scss',
})
export class MergePopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private familyCodeTransmissionService: FamilyCodeTransmissionService,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private dialogRef: DialogRef<MergePopupComponent>
  ) {}
  @ViewChild('auto') auto!: MatAutocomplete;

  searchReq = new FormControl('');
  fcDetails: any = [];
  isLoading: boolean = false;
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  fcData: any[] = [];
  memberList: any[] = [];
  memList: any = {};
  mergeReqCount: number = 0;
  ngOnInit(): void {
    console.log(this.data);
    if (this.data.fcList[0].merged === false)
      this.memberList = this.data.fcList;
    else this.fcData = this.data.fcList;
    this.memList = this.data.fcList.map(
      (item: { member_code: any; record_status: any }) => {
        return { memKey: item.member_code, record: item.record_status };
      }
    );
    this.searchReq.valueChanges.subscribe((value: any) => {
      this.fcDetails = [];
      if (value.length === 12) {
        // if (!this.memList.memKey.includes(value)) {
        this.isLoading = true;
        this.familyCodeTransmissionService
          .fetchDetailsForMerge(value)
          .subscribe({
            next: (response: FamilyCodeResponse) => {
              if (!response.error) {
                if (response.data.length >= 1) this.fcDetails = response.data;
                this.isLoading = false;
              }
            },
            error: (error) => {
              this.isLoading = false;
              this.toaster.error(error);
            },
          });
      }
    });
  }
  mergeClick() {
    // const dialogRef = this.dialog.open(PrimaryMailPopupComponent, {
    //   data: {
    //     fc: this.fcData,
    //     slNo: this.data.slNo,
    //   },
    // });
    // const dialogRef = this.dialog.open(PrimaryAccPopupComponent, {
    //   data: {
    //     fc: this.fcData,

    //     slNo: this.data.slNo,
    //   },
    // });
    this.dialog.open(ConfirmationMergeComponent, {
      data: {
        slNo: this.data.slNo,
        data: this.fcData,
      },
    });
    this.dialogRef.close();
  }
  onSearch() {}
  onDeleteClick(index: any) {
    this.fcData.splice(index, 1);
    this.data.fcList.splice(index, 1);
    this.mergeReqCount--;
    this.searchReq.setValue('');
    this.fcDetails = [];
  }
  restrictFCInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /^[0-9]*$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 11) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  onSelectFCDropDown(row: any) {
    const fc = this.memList.find(
      (item: { memKey: any; record: any }) =>
        row.mem_key === item.memKey && item.record !== 3 && item.record !== 5
    );
    const memKey = this.fcData.find(
      (item) =>
        row.mem_key === item.member_code &&
        item.record_status !== 3 &&
        item.record_status !== 5
    );
    if (memKey != null || memKey != undefined) {
      this.toaster.error('This member has already been added for merge');
      this.searchReq.setValue('');
      this.fcDetails = [];
    } else {
      if (
        (fc != null && (fc.record === 3 || fc.record === 5)) ||
        fc == undefined
      ) {
        const fullName=row.mem_name+(row.mem_surname!==null?(' '+row.mem_surname):'')
     
        if (
          this.data.resData.mem_full_name.toLowerCase() !==fullName.toLowerCase()
        ) {
          const dialogRef = this.dialog.open(FcCodePopupComponent);
          dialogRef.afterClosed().subscribe((value) => {
            if (value) {
              this.fcData = [
                ...this.fcData,
                {
                  family_code: row.mem_family_code,
                  phl_mem_name: row.mem_name,
                  phl_mem_surname: row.mem_surname,
                  member_code: row.mem_key,
                  last_istavrity_date:
                    row.mem_last_transaction_date != null
                      ? row.mem_last_transaction_date
                      : '',
                  added: true,
                },
              ];
              this.mergeReqCount++;
              this.data.fcList = [...this.data.fcList, row.mem_family_code];
            }
            this.searchReq.setValue('');
            this.fcDetails = [];
          });
        } else {
          this.fcData = [
            ...this.fcData,
            {
              family_code: row.mem_family_code,
              phl_mem_name: row.mem_name,
              phl_mem_surname: row.mem_surname,
              member_code: row.mem_key,
              last_istavrity_date:
                row.mem_last_transaction_date != null
                  ? row.mem_last_transaction_date
                  : '',
              added: true,
            },
          ];
          this.mergeReqCount++;
          this.data.fcList = [...this.data.fcList, row.mem_family_code];
        }
      } else {
        this.toaster.error(
          'This FC has already been merged or in pending status'
        );
        this.searchReq.setValue('');
        this.fcDetails = [];
      }
    }
  }
}
